import { ErrorMessage, Field } from "formik";
import { IMAGE_URL } from "../../config";
import cameraIcon from "../../assets/icons/camera.svg";
import get from "lodash/get";
import set from "lodash/set";
import { useState } from "react";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormImageField = ({
  label = "imageField",
  labelClassName = "",
  name = "imageField",
  className = "",
  previewClassName = "",
  ...props
}) => {
  const handleFileChange = async (event, form, name) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(IMAGE_URL, {
        method: "POST",
        body: formData,
      });

      if (response.status === 200) {
        const data = await response.json();
        const filePath = data?.data?.filePath;
        const fullUrl = filePath.startsWith("http")
          ? filePath
          : `https://api.thelocaldaily.in${filePath}`;

        const updatedValues = { ...form.values };
        set(updatedValues, name, fullUrl);
        form.setValues(updatedValues);

        console.log(name, fullUrl, "Upload success");
      } else {
        console.error("Upload failed", response.statusText);
        alert("Image upload failed!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      alert("An error occurred during upload!");
    }
  };

  const handleRemoveImage = (form, name) => {
    const updatedValues = { ...form.values };
    set(updatedValues, name, "");
    form.setValues(updatedValues);
  };

  return (
    <Field name={name}>
      {({ form, meta }) => {
        const file = get(form.values, name);
        const error = meta.touched && meta.error;

        return (
          <div className={`flex flex-col gap-1 ${className} w-full`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                  error ? "text-errorColor" : labelClassName
                }`}
              >
                {formatUnderscoreToSpace(label)}
              </label>
            )}

            <div className="md:w-[8rem] w-[5rem] md:h-[8.3rem] h-[5.3rem] relative overflow-hidden">
              {file ? (
                <div className="relative">
                  <img
                    src={file}
                    alt="Uploaded"
                    className={`md:w-[8rem] w-[5rem] md:h-[8rem] h-[5rem] rounded-lg ${previewClassName}`}
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveImage(form, name)}
                    className="absolute top-0 right-0 bg-gray-400 text-white rounded-full p-[1px] px-[6px] text-xs hover:bg-gray-600"
                    title="Remove image"
                  >
                    x
                  </button>
                </div>
              ) : (
                <label>
                  <div
                    className={`border-[1.5px] md:w-[8rem] w-[5rem] md:h-[8rem] h-[5rem] flex items-center justify-center rounded-lg my-1 bg-white ${
                      error ? "border-errorColor" : "border-greyText"
                    }`}
                  >
                    <img src={cameraIcon} alt="Camera" />
                  </div>
                  <input
                    name="file"
                    type="file"
                    className="invisible"
                    accept="image/*"
                    onChange={(event) => handleFileChange(event, form, name)}
                  />
                </label>
              )}
            </div>

            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        );
      }}
    </Field>
  );
};
